import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import topics from '@/data/topics'

Vue.use(Router)

const PROJECT_NAME = 'chuchupepper'

const BASE_URL = (function (projectName) {
  if (process.env.NODE_ENV !== 'production') {
    return process.env.BASE_URL
  }
  let url = window.location.pathname
  let paths = url.split('/')
  let index = paths.indexOf(projectName)
  let baseUrl = (index !== -1) ? paths.slice(0, index + 1).join('/') : url
  return baseUrl
})(PROJECT_NAME)

const GA_ROOT_PATH = BASE_URL.replace(/\/$/, '')

export const router = new Router({
  mode: 'history',
  base: BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/article',
      name: 'article',
      redirect: '/',
      component: () => import(/* webpackChunkName: "article" */ '@/views/Article'),
      children: [
        ...topics.map(topic => {
          return {
            path: `${topic.id}`,
            name: `article-${topic.id}`,
            component: () => import(/* webpackChunkName: "article" */ `@/views/articles/Article${topic.id}`)
          }
        })
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    //   return { x: 0, y: 0 }
    // }
    return { x: 0, y: 0 }
  }
})

router.onError(err => {
  console.log(err)
})

router.beforeEach((to, from, next) => {
  let path = to.path.replace(/\/$/, '')
  let articlePattern = /^\/article\/(\d+)\/?/
  let title = '柱柱姐勇闖南台灣 | 看懂2020總統立委大選'
  let subtitle = ''
  if (articlePattern.test(path)) {
    let id = Number(path.replace(articlePattern, '$1'))
    if (!isNaN(id)) {
      let topic = topics[id - 1] || null
      subtitle = !topic ? '' : topic.title.replace('\n', ' ')
    }
  }
  document.title = !subtitle ? title : `${subtitle} | ${title}`
  return next()
})

router.beforeResolve((to, from, next) => {
  return next()
})

router.afterEach(function (to, from) {
  Vue.ga('newmedia.send', {
    'hitType': 'pageview',
    'page': `${GA_ROOT_PATH}${to.path}`,
    'title': document.title
  })
})

console.log('[vue-router] base', router.options.base)

export default router
